import React, { FC, ReactElement, ReactNode } from 'react';
import SectionMessage, { SectionMessageAction, SectionMessageActionProps } from '@atlaskit/section-message';
import { Appearance } from '@atlaskit/section-message/types';
import { css } from '@compiled/react';
import { translationKeys, useTranslation } from '../../services/localization';

const styles = css({
  maxWidth: '900px',
});

interface NotificationProps {
  title?: string;
  onClose?: () => void;
  children?: ReactNode;
  actions?: ReactElement<SectionMessageActionProps>[];
}

interface OwnProps extends NotificationProps {
  appearance: Appearance;
}

const Notification: FC<OwnProps> = ({ title, appearance, onClose, children, actions }) => {
  const { translate } = useTranslation();

  const actionsArray: ReactElement<SectionMessageActionProps>[] = [];
  if (actions) {
    actionsArray.push(...actions);
  }
  if (onClose) {
    actionsArray.push(
      <SectionMessageAction
        key={'notification-dismiss-button'}
        testId={'notification-dismiss-button'}
        onClick={onClose}
      >
        {translate(translationKeys.NOTIFICATION_DISMISS_BUTTON_LABEL)}
      </SectionMessageAction>,
    );
  }
  return (
    <div css={styles}>
      <SectionMessage
        appearance={appearance}
        title={title}
        actions={actionsArray.length > 0 ? actionsArray : undefined}
      >
        {children}
      </SectionMessage>
    </div>
  );
};

export const ErrorNotification: FC<NotificationProps> = (props) => <Notification appearance={'error'} {...props} />;

export const SuccessNotifications: FC<NotificationProps> = (props) => (
  <Notification appearance={'success'} {...props} />
);

export const WarningNotification: FC<NotificationProps> = (props) => <Notification appearance={'warning'} {...props} />;
